module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.hasCoordinate) ? _c('gmap-map', {
    staticStyle: {
      "width": "1535px",
      "height": "768px"
    },
    attrs: {
      "center": _vm.centercoordinate,
      "zoom": 16
    }
  }, [_c('gmap-polyline', {
    attrs: {
      "options": {
        'strokeColor': '#FF0000'
      },
      "path": _vm.mappedPath
    }
  }), _vm._v(" "), _c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.infoContent) + "\n    ")]), _vm._v(" "), _vm._l((_vm.markerPath), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": m.coor,
        "clickable": true,
        "draggable": true,
        "icon": m.icon
      },
      on: {
        "mouseover": function($event) {
          return _vm.toggleInfoWindow(m, index)
        }
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.hasCoordinate) ? _c('p', [_vm._v(" No coordinates available for this runner!")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fc84faa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/GoogleMap.vue
// module id = 1616
// module chunks = 2